import { useAdministrativeContext } from '../../../../../../../pages/administrativePanel/administrativePanelContext'
import { api } from '../../../../../../../services/api'
import { useState, useEffect } from 'react'
import { FaSearch } from 'react-icons/fa'
import { toast } from 'react-toastify'

import { Container } from './style'



export function InputContent({ 
    setListSearchBusiness, 
    setHandleTermSearch,
    setPageSearch,
    setSearchLoading,
    setShowingFilteredBusiness,
    statusSelected 
}) {
    const { setSyncInformations, getBusinessAdm, quantityBusinessToFetch } = useAdministrativeContext()
    const [searchTerm, setSearchTerm] = useState('')
   
    const editedSearchTerm = searchTerm.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase()
    
    async function fetchingSearchBusiness (event) {
        event.preventDefault()

        if(editedSearchTerm === '')
            return

        setSearchLoading(true)
        try{
            const response = await api.get(`/getBusinessAdm/?quantity=20&search=${editedSearchTerm}&sync=${statusSelected}`, {
                headers: {
                  token: localStorage.getItem('@Inoveclube:token')
                }
            })
    
            const { business, next_page, syncInformations } = response.data
            

            setListSearchBusiness(business)
            setShowingFilteredBusiness(true)
            setHandleTermSearch(editedSearchTerm)
            setSyncInformations(syncInformations)
            setPageSearch(next_page ? 40 : null)
            setSearchLoading(false)
        }catch{
            setSearchLoading(false)
            toast.error('Tente novamente')
        }
      
    }


    useEffect(() => {
        if(searchTerm === ''){
            setListSearchBusiness([])
            setShowingFilteredBusiness(false)
            getBusinessAdm(false, quantityBusinessToFetch)
        }
    }, [searchTerm, setListSearchBusiness, getBusinessAdm, quantityBusinessToFetch, setShowingFilteredBusiness])


    return(
        <Container onSubmit={fetchingSearchBusiness}>
            <input 
                placeholder="Buscar empresa"
                value={searchTerm}
                autoFocus
                onChange={event => setSearchTerm(event.target.value)}
            />

            <button type='submit'> 
                <FaSearch />
            </button>
        </Container>
    )
}
